var scrypt = require('scrypt')

function hash(key, salt, n, r, p, dklen, progressCb) {
  return scrypt.hashSync(key, { N: n, r: r, p: p }, dklen, salt)
}

module.exports = hash



//////////////////
// WEBPACK FOOTER
// ./~/ganache-core/~/scrypt.js/node.js
// module id = 628
// module chunks = 0 1 2